<template>
    <div class="no-permission__block card card-small mb-4">
        <h3 class="no-permission__title">You haven't access to this content</h3>
        <p>Sorry, but you haven't permission, to see content on this page</p>
    </div>
</template>

<script>
export default {
    name: 'noPermissionMessage'
}
</script>

<style scoped>
    .no-permission__block {
        text-align: center;
    }

    .no-permission__title {
        margin-top: 20px;
    }
</style>
